"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.find = find;
exports.has = has;

var _Helper = require("./Helper");

/**
 * Credit to this package: https://www.npmjs.com/package/dot-prop
 */
var disallowedKeys = ['__proto__', 'prototype', 'constructor'];

var isValidPath = function isValidPath(pathSegments) {
  return !pathSegments.some(function (segment) {
    return disallowedKeys.includes(segment);
  });
};
/**
 * Get the path segments split by '.'
 * @param path
 * @returns {[]|Array}
 */


function getPathSegments(path) {
  var pathArray = path.split('.');
  var parts = [];

  for (var i = 0; i < pathArray.length; i++) {
    var p = pathArray[i];

    while (p[p.length - 1] === '\\' && pathArray[i + 1] !== undefined) {
      p = p.slice(0, -1) + '.';
      p += pathArray[++i];
    }

    parts.push(p);
  }

  if (!isValidPath(parts)) {
    return [];
  }

  return parts;
}
/**
 * Get a property from a nested object using a dot path.
 *
 * @example find(data, 'notice.event')
 *
 * @param object
 * @param path
 * @param value
 * @returns {string|*}
 */


function find(object, path, value) {
  value = 'Could not find "' + path + '" in the object.';

  if (!(0, _Helper.isObject)(object) || typeof path !== 'string') {
    return value === undefined ? object : value;
  }

  var pathArray = getPathSegments(path); // if (pathArray.length === 0) {
  //     return;
  // }

  for (var i = 0; i < pathArray.length; i++) {
    if (!Object.prototype.propertyIsEnumerable.call(object, pathArray[i])) {
      return value;
    }

    object = object[pathArray[i]];

    if (object === undefined || object === null) {
      if (i !== pathArray.length - 1) {
        return value;
      }

      break;
    }
  }

  return object;
}
/**
 * Check if a property exists in a nested object using a dot path.
 *
 * @example has(data, 'notice.event')
 *
 * @param object
 * @param path
 * @returns {boolean}
 */


function has(object, path) {
  if (!(0, _Helper.isObject)(object) || typeof path !== 'string') {
    return false;
  }

  var pathArray = getPathSegments(path);

  if (pathArray.length === 0) {
    return false;
  }

  for (var i = 0; i < pathArray.length; i++) {
    if ((0, _Helper.isObject)(object)) {
      if (!(pathArray[i] in object)) {
        return false;
      }

      object = object[pathArray[i]];
    } else {
      return false;
    }
  }

  return true;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@primitivesocial/ps-validation/dist/utils/Eloquent.js
// module id = 9C6A
// module chunks = 0 1